<div class="p0-menu-screen" *ngIf="showMenu">
  <!-- <fa-icon class="p0-menu-close" [icon]="faTimesHexagon" title="Menu" (click)="swapFlag()"></fa-icon> -->
  <nav>
    <a routerLink="{{ link.slug }}" *ngFor="let link of links" routerLinkActive="active" (click)="swapFlag()">
      <div>{{ link.name }}</div>
    </a>
  </nav>
</div>
